import { FormattedMessage, type IntlShape, useIntl } from 'react-intl';
import Select, { type SelectOption } from '@rio-cloud/rio-uikit/Select';
import { useAppDispatch, useAppSelector } from '../../../configuration/setup/hooks';
import {
    companyInfoLocaleSelector,
    setCompanyInfoField,
    setIsCompanyLocaleManuallySelected,
} from '../companyInfoSlice';
import { getLanguageDropDownItems } from '../languageHelpers';
import type { LanguageDropdownItem } from '../../../configuration/types';
import { useId, useMemo } from 'react';

export const LanguageSelect = (props: { id?: string; required?: boolean; tenant: string }) => {
    const dispatch = useAppDispatch();
    const language = useAppSelector(companyInfoLocaleSelector);
    const tenant = props.tenant;
    const intl = useIntl();

    const generatedId = useId();
    const finalId = props.id || generatedId;

    const selectedValue = language;

    const options = useMemo(
        () => getOptions(tenant, language, intl, selectedValue),
        [tenant, language, intl, selectedValue]
    );

    return (
        <div className={'form-group'}>
            <div className={'col-xs-6 margin-top-10 margin-bottom-5'}>
                <div className={'form-group'}>
                    <label className={'control-label'} htmlFor={finalId}>
                        <FormattedMessage id={'registration.companyData.language'} />
                        {props.required ? '*' : null}
                    </label>
                    <Select
                        id={finalId}
                        className={'inputLanguage'}
                        dropdownClassName={'max-height-150'}
                        name={'companyLanguage'}
                        useFilter
                        onChange={(item: SelectOption | undefined) => {
                            if (item) {
                                dispatch(setIsCompanyLocaleManuallySelected(true));
                                dispatch(setCompanyInfoField({ fieldName: 'language', value: item.id }));
                            }
                        }}
                        options={options}
                    />
                </div>
            </div>
        </div>
    );
};

const getOptions = (tenant: string, language: string, intl: IntlShape, selectedValue: string) =>
    getLanguageDropDownItems(tenant, language, intl).map((option: LanguageDropdownItem) => ({
        ...option,
        selected: option.id === selectedValue,
    }));
